export enum ConformityModule {
  A = "A",
  A1 = "A1",
  A2 = "A2",
  B = "B",
  C = "C",
  C1 = "C1",
  C2 = "C2",
  D = "D",
  D1 = "D1",
  E = "E",
  E1 = "E1",
  F = "F",
  F1 = "F1",
  G = "G",
  H = "H",
  H1 = "H1",
}
